import { environmentConfig } from "@src/appV2/environment";
import { NavigationMenuSectionTitle } from "@src/appV2/redesign/AppLayout/Navigation/MenuSectionTitle";
import { getLocation } from "@src/appV2/redesign/utils/routes";

import { NavigationMenuItem } from "../../../appV2/redesign/AppLayout/Navigation/MenuItem";
import { useAdminMenuPriviligesProviderContext } from "./priviligesProviders/AdminMenuPriviligesProvider";

/* eslint-disable complexity, max-lines */
export function AdminNavigationMenuItemsContainer() {
  const adminMenuPriviliges = useAdminMenuPriviligesProviderContext();

  const currentLocation = location.pathname;

  // Accounts
  const adminAccountsAgentsLoc = getLocation("adminAccountsAgents");
  const adminAccountsFacilitiesLoc = getLocation("adminAccountsFacilities");
  const adminAccountsEmployeesLoc = getLocation("adminAccountsEmployees");
  const adminAccountsRequirementLoc = getLocation("adminAccountsRequirement");
  const adminAccountsLocationsLoc = getLocation("adminAccountsLocations");
  const adminAccountsChangeLogLoc = getLocation("adminAccountsChangeLog");
  const adminAccountsExclusionsLoc = getLocation("adminAccountsExclusions");
  const adminAccountsPlacementCandidateBansLoc = getLocation("adminAccountsPlacementCandidateBans");

  // Shifts
  const adminShiftsLoc = getLocation("adminShifts");
  const adminLogsShiftLoc = getLocation("adminLogsShift");
  const adminTimeclockLoc = getLocation("adminTimeclock");
  const adminUrgentShiftNcnsLoc = getLocation("adminUrgentShiftNcns");

  // Invoice
  const adminAccountsInvocingByPeriodLoc = getLocation("adminAccountsInvocingByPeriod");
  const adminAccountsInvocingByNumberLoc = getLocation("adminAccountsInvocingByNumber");
  const adminAccountsPostInvoiceDisputesLoc = getLocation("adminAccountsPostInvoiceDisputes");
  const adminAccountsPreInvoiceDisputesLoc = getLocation("adminAccountsPreInvoiceDisputes");

  // Payroll
  const agentProofLoc = getLocation("agentProof");
  const adminShiftPaymentsPayRatesLoc = getLocation("adminShiftPaymentsPayRates");

  // Admin Tools
  const adminToolsTimekeepingVideosLoc = getLocation("adminToolsTimekeepingVideos");
  const adminToolsShiftExplainerLoc = getLocation("adminToolsShiftExplainer");
  const adminToolsJobsScraperLoc = getLocation("adminToolsJobsScraper");

  // Staffing
  const adminManageQualificationsLoc = getLocation("adminManageQualifications");
  const adminManageWorkplaceTypesLoc = getLocation("adminManageWorkplaceTypes");
  const adminManageSkillsAssessmentsLoc = getLocation("adminManageSkillsAssessments");

  // Hiring
  const adminPlacementsAvailabilityLoc = getLocation("adminPlacementsAvailability");
  return (
    <>
      {adminMenuPriviliges.accountsSection && (
        <>
          <NavigationMenuSectionTitle>Accounts</NavigationMenuSectionTitle>
          {adminMenuPriviliges.accountsSection.hcps && (
            <NavigationMenuItem
              iconType="person-male-formal"
              isSelected={adminAccountsAgentsLoc.pathname === currentLocation}
              routeTo={adminAccountsAgentsLoc}
            >
              HCPs
            </NavigationMenuItem>
          )}
          {adminMenuPriviliges.accountsSection.workplaces && (
            <NavigationMenuItem
              iconType="building-thick"
              isSelected={adminAccountsFacilitiesLoc.pathname === currentLocation}
              routeTo={adminAccountsFacilitiesLoc}
            >
              Workplaces
            </NavigationMenuItem>
          )}
          {adminMenuPriviliges.accountsSection.employees && (
            <NavigationMenuItem
              iconType="people"
              isSelected={adminAccountsEmployeesLoc.pathname === currentLocation}
              routeTo={adminAccountsEmployeesLoc}
            >
              Employees
            </NavigationMenuItem>
          )}
          {adminMenuPriviliges.accountsSection.requirements && (
            <NavigationMenuItem
              iconType="notepad-alt"
              isSelected={adminAccountsRequirementLoc.pathname === currentLocation}
              routeTo={adminAccountsRequirementLoc}
            >
              Requirements
            </NavigationMenuItem>
          )}
          {adminMenuPriviliges.accountsSection.locations && (
            <NavigationMenuItem
              iconType="location-alt"
              isSelected={adminAccountsLocationsLoc.pathname === currentLocation}
              routeTo={adminAccountsLocationsLoc}
            >
              Locations
            </NavigationMenuItem>
          )}
          {adminMenuPriviliges.accountsSection.changeLog && (
            <NavigationMenuItem
              iconType="stack-vertical"
              isSelected={adminAccountsChangeLogLoc.pathname === currentLocation}
              routeTo={adminAccountsChangeLogLoc}
            >
              Change Log
            </NavigationMenuItem>
          )}
          {adminMenuPriviliges.accountsSection.dnrs && (
            <NavigationMenuItem
              iconType="padlock-locked"
              isSelected={adminAccountsExclusionsLoc.pathname === currentLocation}
              routeTo={adminAccountsExclusionsLoc}
            >
              DNRs
            </NavigationMenuItem>
          )}
        </>
      )}

      {adminMenuPriviliges.shiftsSection && (
        <>
          <NavigationMenuSectionTitle>Shifts</NavigationMenuSectionTitle>
          {adminMenuPriviliges.shiftsSection.shiftSearch && (
            <NavigationMenuItem
              iconType="magnifying-glass"
              isSelected={adminShiftsLoc.pathname === currentLocation}
              routeTo={adminShiftsLoc}
            >
              Shift Search
            </NavigationMenuItem>
          )}
          {adminMenuPriviliges.shiftsSection.shiftsVerification && (
            <NavigationMenuItem
              iconType="badge-check"
              isSelected={false}
              onClick={() => {
                window.open(
                  environmentConfig.REACT_APP_SHIFT_VERIFICATION_BASE_URL,
                  "_blank",
                  "noopener,noreferrer"
                );
              }}
            >
              Shifts Verification
            </NavigationMenuItem>
          )}
          {adminMenuPriviliges.shiftsSection.shiftLogs && (
            <NavigationMenuItem
              iconType="folder-view"
              isSelected={adminLogsShiftLoc.pathname === currentLocation}
              routeTo={adminLogsShiftLoc}
            >
              Shift Logs
            </NavigationMenuItem>
          )}
          {adminMenuPriviliges.shiftsSection.timeclockRequests && (
            <NavigationMenuItem
              iconType="clock"
              isSelected={adminTimeclockLoc.pathname === currentLocation}
              routeTo={adminTimeclockLoc}
            >
              Timeclock Requests
            </NavigationMenuItem>
          )}
          {adminMenuPriviliges.shiftsSection.noShows && (
            <NavigationMenuItem
              iconType="gps-disabled"
              isSelected={adminUrgentShiftNcnsLoc.pathname === currentLocation}
              routeTo={adminUrgentShiftNcnsLoc}
            >
              No Shows
            </NavigationMenuItem>
          )}
        </>
      )}

      {adminMenuPriviliges.invoiceSection && (
        <>
          <NavigationMenuSectionTitle>Invoice</NavigationMenuSectionTitle>
          {adminMenuPriviliges.invoiceSection.byPeriod && (
            <NavigationMenuItem
              iconType="centered-circle"
              isSelected={adminAccountsInvocingByPeriodLoc.pathname === currentLocation}
              routeTo={adminAccountsInvocingByPeriodLoc}
            >
              By Period
            </NavigationMenuItem>
          )}
          {adminMenuPriviliges.invoiceSection.byNumber && (
            <NavigationMenuItem
              iconType="dash"
              isSelected={adminAccountsInvocingByNumberLoc.pathname === currentLocation}
              routeTo={adminAccountsInvocingByNumberLoc}
            >
              By Number
            </NavigationMenuItem>
          )}
          {adminMenuPriviliges.invoiceSection.postInvoiceDisputes && (
            <NavigationMenuItem
              iconType="caret-double-right"
              isSelected={adminAccountsPostInvoiceDisputesLoc.pathname === currentLocation}
              routeTo={adminAccountsPostInvoiceDisputesLoc}
            >
              Post-Invoice Disputes
            </NavigationMenuItem>
          )}
          {adminMenuPriviliges.invoiceSection.preInvoiceDisputes && (
            <NavigationMenuItem
              iconType="caret-double-left"
              isSelected={adminAccountsPreInvoiceDisputesLoc.pathname === currentLocation}
              routeTo={adminAccountsPreInvoiceDisputesLoc}
            >
              Pre-Invoice Disputes
            </NavigationMenuItem>
          )}
        </>
      )}

      {adminMenuPriviliges.payrollSection && (
        <>
          <NavigationMenuSectionTitle>Payroll</NavigationMenuSectionTitle>
          {adminMenuPriviliges.payrollSection.proofOfEarning && (
            <NavigationMenuItem
              iconType="money-dollar"
              isSelected={agentProofLoc.pathname === currentLocation}
              routeTo={agentProofLoc}
            >
              Proof of Earnings
            </NavigationMenuItem>
          )}
          {adminMenuPriviliges.payrollSection.shiftPayments && (
            <NavigationMenuItem
              iconType="palm-dollar"
              isSelected={adminShiftPaymentsPayRatesLoc.pathname === currentLocation}
              routeTo={adminShiftPaymentsPayRatesLoc}
            >
              Shift Payments
            </NavigationMenuItem>
          )}
        </>
      )}

      {adminMenuPriviliges.adminToolsSection && (
        <>
          <NavigationMenuSectionTitle>Admin Tools</NavigationMenuSectionTitle>
          {adminMenuPriviliges.adminToolsSection.timekeepingVideos && (
            <NavigationMenuItem
              iconType="replay"
              isSelected={adminToolsTimekeepingVideosLoc.pathname === currentLocation}
              routeTo={adminToolsTimekeepingVideosLoc}
            >
              Shift Explainer
            </NavigationMenuItem>
          )}
          {adminMenuPriviliges.adminToolsSection.shiftExplainer && (
            <NavigationMenuItem
              iconType="information-circle"
              isSelected={adminToolsShiftExplainerLoc.pathname === currentLocation}
              routeTo={adminToolsShiftExplainerLoc}
            >
              Shift Explainer
            </NavigationMenuItem>
          )}
          {adminMenuPriviliges.adminToolsSection.jobsScraper && (
            <NavigationMenuItem
              iconType="briefcase"
              isSelected={adminToolsJobsScraperLoc.pathname === currentLocation}
              routeTo={adminToolsJobsScraperLoc}
            >
              Jobs Scraper
            </NavigationMenuItem>
          )}
        </>
      )}

      {adminMenuPriviliges.staffingSection && (
        <>
          <NavigationMenuSectionTitle>Staffing</NavigationMenuSectionTitle>
          {adminMenuPriviliges.staffingSection.qualifications && (
            <NavigationMenuItem
              iconType="medal-star-alt"
              isSelected={adminManageQualificationsLoc.pathname === currentLocation}
              routeTo={adminManageQualificationsLoc}
            >
              Qualifications
            </NavigationMenuItem>
          )}
          {adminMenuPriviliges.staffingSection.workplaceTypes && (
            <NavigationMenuItem
              iconType="house-building"
              isSelected={adminManageWorkplaceTypesLoc.pathname === currentLocation}
              routeTo={adminManageWorkplaceTypesLoc}
            >
              Workplace Types
            </NavigationMenuItem>
          )}
          {adminMenuPriviliges.staffingSection.skillAssessments && (
            <NavigationMenuItem
              iconType="files"
              isSelected={adminManageSkillsAssessmentsLoc.pathname === currentLocation}
              routeTo={adminManageSkillsAssessmentsLoc}
            >
              Workplace Types
            </NavigationMenuItem>
          )}
        </>
      )}

      {adminMenuPriviliges.hiringSection && (
        <>
          <NavigationMenuSectionTitle>Hiring</NavigationMenuSectionTitle>
          {adminMenuPriviliges.hiringSection.availability && (
            <NavigationMenuItem
              iconType="clock"
              isSelected={adminPlacementsAvailabilityLoc.pathname === currentLocation}
              routeTo={adminPlacementsAvailabilityLoc}
            >
              Availability
            </NavigationMenuItem>
          )}
          {adminMenuPriviliges.hiringSection.bans && (
            <NavigationMenuItem
              iconType="notepad-problem"
              isSelected={adminAccountsPlacementCandidateBansLoc.pathname === currentLocation}
              routeTo={adminAccountsPlacementCandidateBansLoc}
            >
              Bans
            </NavigationMenuItem>
          )}
        </>
      )}
    </>
  );
}
/* eslint-enable complexity, max-lines */
